module.exports = __webpack_public_path__ + "img/coin-default.0a95280f.svg";